export function modal() {
    document.addEventListener('DOMContentLoaded', () => {
        const closeModalButtons = document.querySelectorAll('.tdc-btn-close');
        const openModalButtons = document.querySelectorAll('.modal-button-show');
        const modals = document.getElementsByTagName('dialog');
        openModalButtons.forEach((openModalButton) => {
            const anchor = openModalButton.getAttribute('data-modal'); // ID of dialog
            openModalButton.addEventListener('click', () => {
                if (anchor) {
                    const dialog = document.getElementById(anchor);
                    if (dialog) {
                        dialog.showModal();
                    }
                }
            });
        });
        closeModalButtons.forEach((closeModalButton) => {
            closeModalButton.addEventListener('click', () => {
                if (modals) {
                    const modalIndex = Array.from(modals);
                    if (modalIndex) {
                        modalIndex.forEach((modal) => {
                            modal.close();
                        });
                    }
                }
            });
        });
    });
}
//# sourceMappingURL=modal.js.map